import React, { useState, useEffect } from "react";
import {
  Button,
  Col,
  Form,
  FormControl,
  FormGroup,
  Grid,
  InputGroup,
  Row,
  Alert,
} from "react-bootstrap";
import "./login.page.css";

import * as ZUtils from "../../../modules/zutils";
import { IZLoginModule } from "../../../modules/zcommon/contracts";

type LoginViewMode = "login" | "recovery";

export interface OwnProps { }

export interface ConnectedState {
  zLoginModule: IZLoginModule;
}

export interface ConnectedDispatch {
  despacharLogin: (idApl?: string, nombreOpcion?: string) => void;
  usernameChanged: (username: string) => void;
  passwordChanged: (password: string) => void;
  despacharCambiarContrasena: (idApl?: string, nombreOpcion?: string) => void;
}

export const LoginPage: React.FunctionComponent<OwnProps & ConnectedState & ConnectedDispatch> = (props) => {
  const [showAlert, setShowAlert] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [viewMode, setViewMode] = useState<LoginViewMode>("login");
  const [alertViewMode, setAlertViewMode] = useState<LoginViewMode>("login");
  const [requestViewMode, setRequestViewMode] = useState<LoginViewMode>("login");

  const isRecoveryView = viewMode === "recovery";

  const getCommandParams = () => ({
    idApl: ZUtils.Services.getQueryStringParameter("idApl") || undefined,
    nombreOpcion: ZUtils.Services.getQueryStringParameter("opcion") || undefined,
  });

  const setMessage = () => {
    let msj_pattern = /<msj>(.*?)<\/msj>/;
    var msj_match = props.zLoginModule.msg.match(msj_pattern);
    if (msj_match) {
      // console.log("================AZEN-MSG================");

      // console.log(props.zLoginModule.msg.match(msj_pattern))
      setShowAlert(msj_match[1]);
      setAlertViewMode(requestViewMode);
    }else{
      setShowAlert('');
    }
  }

  function handleKeyPress(event: any) {
    if (event.key === 'Enter') {
      onIngresarClick();
    }
  }

  function handleRecoveryKeyPress(event: any) {
    if (event.key === 'Enter') {
      onRecuperarContrasenaSubmit();
    }
  }

  const onIngresarClick = () => {
    const { idApl, nombreOpcion } = getCommandParams();
    setRequestViewMode("login");
    props.despacharLogin(idApl, nombreOpcion);
  };

  const onRecuperarContrasenaSubmit = () => {
    const { idApl, nombreOpcion } = getCommandParams();
    setRequestViewMode("recovery");
    props.despacharCambiarContrasena(idApl || undefined, nombreOpcion || undefined);
  };

  const onCambiarContrasenaClick = () => {
    setShowAlert('');
    setShowPassword(false);
    setViewMode("recovery");
  };

  const onVolverLoginClick = () => {
    setShowAlert('');
    setShowPassword(false);
    setViewMode("login");
  };

  const onUsernameChanged = (e: any) => {
    props.usernameChanged(e.target.value);
  };

  const onPasswordChanged = (e: any) => {
    props.passwordChanged(e.target.value);
  };

  const togglePasswordVisibility = () => {
    setShowPassword((currentValue) => !currentValue);
  };

  const onPasswordToggleKeyDown = (event: React.KeyboardEvent<any>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      togglePasswordVisibility();
    }
  };

  useEffect(() => {
    setMessage();
  }, [props.zLoginModule.msg]);

  return (
    <div className="fondo-login">
      <Grid className="mt-5">
        <Row className="mt-5 ml-5 mr-5">
          <Col lg={5} md={6} sm={12} className="bienvenido text-primary">
            <h1 className="shadow-sm text-primary mt-8 p-3 text-center rounded titulo-bienvenido">
              {/* Bienvenid@ */}
            </h1>
            <img
              className="logo"
              src="azenweb\dist\img\azen-future.png"
              alt=""
            />
            {/* <img
              src="azenweb\src\img\oig2r.png"
              alt="icon"
              style={{marginTop: "5%", padding: "5px", width: "auto", height: "60%", maxWidth: "80%"}}
            />   */}
          </Col>

          <Col
            lg={7}
            md={6}
            sm={12}
            className="p-5 m-auto shadow-sm rounded-lg text-center container-login"
          >
            <h3 className="shadow-sm  mt-30 p-3 text-center rounded ">
              <strong>{isRecoveryView ? "Recuperar contraseña" : "Iniciar sesión"}</strong>
            </h3>

            {/* <img
              className="mt-5"
              src="https://img.icons8.com/cute-clipart/64/26e07f/password.png"
              alt="icon"
            />  */}

            {isRecoveryView ? (
              <Form className="m-30 login-recovery-form">
                <p className="login-recovery-copy">
                  Ingresa tu usuario para continuar con la recuperación de contraseña.
                </p>

                <FormGroup controlId="formRecoveryUser">
                  <h5 className="shadow-sm mt-30 p-3 text-left rounded ">
                    <strong> Usuario: </strong>
                  </h5>
                  <FormControl
                    type="username"
                    placeholder="usuario"
                    value={props.zLoginModule.username}
                    onChange={onUsernameChanged}
                    onKeyPress={handleRecoveryKeyPress}
                  />
                </FormGroup>

                <div className="login-recovery-actions">
                  <Button
                    bsStyle="primary btn-block mt-5 mb-5 btn-signin"
                    bsSize="large"
                    type="button"
                    onClick={onRecuperarContrasenaSubmit}
                  >
                    Continuar
                  </Button>

                  <button
                    type="button"
                    className="login-link-button"
                    onClick={onVolverLoginClick}
                  >
                    Volver al inicio de sesión
                  </button>
                </div>
              </Form>
            ) : (
              <Form className="m-30">
                <FormGroup controlId="formBasicEmail">
                  <h5 className="shadow-sm mt-30 p-3 text-left rounded "> <strong> Usuario: </strong> </h5>
                  <FormControl
                    type="username"
                    placeholder="usuario"
                    value={props.zLoginModule.username}
                    onChange={onUsernameChanged}
                    onKeyPress={handleKeyPress}
                  />
                </FormGroup>

                <FormGroup controlId="formBasicPassword">
                  <h5 className="shadow-sm mt-30 p-3 text-left rounded ">
                    <strong> Contraseña: </strong>
                  </h5>
                  <InputGroup className="login-password-group">
                    <FormControl
                      type={showPassword ? "text" : "password"}
                      placeholder="°°°"
                      value={props.zLoginModule.password}
                      onChange={onPasswordChanged}
                      onKeyPress={handleKeyPress}
                    />
                    <InputGroup.Addon
                      className="login-password-toggle"
                      role="button"
                      tabIndex={0}
                      title={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                      aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                      aria-pressed={showPassword}
                      onClick={togglePasswordVisibility}
                      onKeyDown={onPasswordToggleKeyDown}
                    >
                      <span
                        className={showPassword ? "glyphicon glyphicon-eye-close" : "glyphicon glyphicon-eye-open"}
                        aria-hidden="true"
                      />
                    </InputGroup.Addon>
                  </InputGroup>
                </FormGroup>

                <Button
                  bsStyle="primary btn-block mt-5 mb-5 btn-signin"
                  bsSize="large"
                  type="button"
                  onClick={onIngresarClick}
                >
                  Ingresar
                </Button>

                {/* <button
                  type="button"
                  className="login-link-button"
                  onClick={onCambiarContrasenaClick}
                >
                  ¿Ha olvidado su contraseña?
                </button> */}
              </Form>
            )}

              {/* {props.zLoginModule.msg} */}
              {showAlert && alertViewMode === viewMode && (
                <Alert bsStyle={isRecoveryView ? "info" : "danger"} className="login-alert">
                  {showAlert}
                </Alert>
              )}
          </Col>
        </Row>
        <footer className="text-right py-3">
          AZEN,   {new Date().getFullYear()} &copy;
        </footer>
      </Grid>

    </div>
  );
};



// WEBPACK FOOTER //
// ./src/portal/pages/login/Login.page.tsx